import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router';

class FeatureClass extends React.Component {
   render() {
      return (
         <div>
            <Navbar className="Header" >
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/featureClass/" activeStyle={{ color: 'red' }} >FeatureClass</Link>
                  </Navbar.Brand>
               </Navbar.Header>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}
FeatureClass.propTypes = {
   children: PropTypes.object.isRequired
};
export default FeatureClass;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/FeatureClass/FeatureClass.js
 **/